export const path = "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM5.37561 7V5H13.3756V13H11.3756V8.62793L6.52692 13.4766L5 11.9497L9.94971 7H5.37561Z"
